import InfoBlock from "./info-block.js";
export default InfoBlock;
